import { AxiosPromise } from 'axios';
import { proxyAPI } from '../httpClient';
import getUserData from '../../utils/user';

const planQuery = {
  fetchCoveragePlan(): AxiosPromise {
    const userData = getUserData();
    return proxyAPI.get(
      `gfh-shield-plan-service/coverage/v2/reservations?accountId=${userData?.guestyAccountId}`
    );
  },
};

export default planQuery;
